<template>
  <div class="flex">
    <!-- 日.月租量 -->
    <div class="rent">
      <!-- 月租 -->
      <div class="month"  :style="{float:(brandList.length===1 ? 'left':'')}">
        <div class="month_total">
          <span>{{ totalData[0] ? totalData[0].totolRent : 0 }}</span>
          <p>月租量</p>
        </div>
        <div v-if="totalData[0] && totalData[0].data" class="month_list"
             :style="{flex:(brandList.length===1 ? '':'1')}">
          <i
            class="el-icon-arrow-left"
            v-if="totalData[0].isL4"
            @click="pre(0)"
          ></i>
          <i
            class="el-icon-arrow-right"
            v-if="totalData[0].isL4"
            @click="next(0)"
          ></i>
          <div
            v-for="item in totalData[0].data"
            :key="item.name"
            :style="brandList.length===1?'width:130px':'width:45px'"
            :class="{ isL4: totalData[0].isL4 }"
          >
            <div>{{ item.name }}</div>
            <div>{{ item.rent }}</div>
          </div>
        </div>
      </div>
      <div class="month day">
        <div v-if="totalData[1]" class="month_total">
          <span>{{ totalData[1] ? totalData[1].totolRent : 0 }}</span>
          <p>日租量</p>
        </div>
        <div v-if="totalData[1] && totalData[1].data" class="month_list"
             :style="{flex:(brandList.length===1 ? '':'1')}">
          <i
            class="el-icon-arrow-left"
            v-if="totalData[1].isL4"
            @click="pre(1)"
          ></i>
          <i
            class="el-icon-arrow-right"
            v-if="totalData[1].isL4"
            @click="next(1)"
          ></i>
          <div
            v-for="item in totalData[1].data"
            :key="item.name"
            :style="{width:(brandList.length===1 ? '130px':'45px')}"
            :class="{ isL4: totalData[1].isL4}"
          >
            <div>{{ item.name }}</div>
            <div>{{ item.rent }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="chart_q">
      <h4>前7天日租车数量曲线图</h4>
      <div id="c2" v-show="!loading && userLevel > 1"></div>
    </div>
  </div>
</template>

<script>
import Api from '@/api'
import { Line } from '@antv/g2plot'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      dynamicTimer: null,
      totalData: [],
      realNames: [],
      chart: null,
      loading: true,
      // 单车品牌颜色
      brandOriginColor: {},
      // 电动车品牌颜色
      eOriginColor: {}
    }
  },
  props: {
    selfAreaId: {
      default: '',
      type: String
    },
    isAggregation: {
      default: '',
      type: [Boolean, String]
    },
    brandList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  computed: {
    ...mapGetters(['userLevel', 'userBikeType']),
    isBicycle() {
      // 判断用户账号属性为自行车或者包含电动车及自行车
      return (this.userBikeType === 0 || this.userBikeType === 2)
    },
    isElectricBike() {
      // 判断用户账号属性为电动车或者包含电动车及自行车
      return (this.userBikeType === 1 || this.userBikeType === 2)
    }
  },
  mounted() {
    if (this.selfAreaId !== '') {
      this.getAreaBrandDetails()
    }
  },
  created() {
    console.log(this.brandList)
    if (this.selfAreaId !== '') {
      this.getAreaBrandDetails()
        .then(() => {
          this.getDynamicApi()
        })
    }
  },
  watch: {
    selfAreaId() {
      this.getAreaBrandDetails()
        .then(() => {
          this.getDynamicApi()
        })
    }
  },
  methods: {
    async getAreaBrandDetails() {
      this.eOriginColor = {}
      this.brandOriginColor = {}
      if (this.selfAreaId !== '') {
        try {
          const params = {
            selfAreaId: this.selfAreaId
          }
          await Api.areaBrandDetails(params).then((res) => {
            if (res.code === 200) {
              const brandOriginColor = res.data.map(item => {
                return {
                  brandName: item.brandName.slice(0, 2) + '单车',
                  bikeColor: item.bikeColor
                }
              })
              // 单车
              const colorObject = brandOriginColor => {
                for (let i = 0; i < brandOriginColor.length; i++) {
                  const { brandName, bikeColor } = brandOriginColor[i]
                  this.brandOriginColor[brandName] = bikeColor
                }
                return this.brandOriginColor
              }
              this.brandOriginColor = colorObject(brandOriginColor)
              // 电动车
              const eBrandOriginColor = res.data.map(item => {
                if (item.brandName.indexOf('美团出行') > -1) {
                  return {
                    brandName: '美团电单',
                    eBikeColor: item.ebikeColor
                  }
                }
                return {
                  brandName: item.brandName,
                  eBikeColor: item.ebikeColor
                }
              })
              const eColorObject = eBrandOriginColor => {
                for (let i = 0; i < eBrandOriginColor.length; i++) {
                  const { brandName, eBikeColor } = eBrandOriginColor[i]
                  this.eOriginColor[brandName] = eBikeColor
                }
                return this.eOriginColor
              }
              this.eOriginColor = eColorObject(eBrandOriginColor)
            } else {
              console.log('汇总区域品牌信息为空-statistics')
            }
          })
        } catch (e) {
          this.eOriginColor = {}
          this.brandOriginColor = {}
        }
      }
    },
    // 自行车品牌颜色
    originColor(name) {
      return this.brandOriginColor[name]
    },
    // 电动车品牌颜色
    eBrandOriginColor(name) {
      return this.eOriginColor[name]
    },
    color16() {
      var r = Math.floor(Math.random() * 256)
      var g = Math.floor(Math.random() * 256)
      var b = Math.floor(Math.random() * 256)
      var color = '#' + r.toString(16) + g.toString(16) + b.toString(16)
      return color
    },
    getColorsByNames() {
      const colorMap = {}
      for (let i = 0, len = this.realNames.length; i < len; i++) {
        const item = this.realNames[i]
        let color
        if (item.indexOf('单车') !== -1) {
          color = this.originColor(item) ? this.originColor(item) : this.color16()
        } else {
          color = this.eBrandOriginColor(item) ? this.eBrandOriginColor(item) : this.color16()
        }
        colorMap[item] = color
      }
      return colorMap
    },
    GetDateStr(AddDayCount = 0, str = true) {
      var dd = new Date()
      dd.setDate(dd.getDate() + AddDayCount) // 获取AddDayCount天后的日期
      var y = dd.getFullYear()
      var m = dd.getMonth() + 1 // 获取当前月份的日期
      var d = dd.getDate()
      m = m < 10 ? '0' + m : m
      d = d < 10 ? '0' + d : d
      if (str) {
        return y + '-' + m + '-' + d
      } else {
        return {
          y,
          m,
          d
        }
      }
    },
    async getDynamicApi() {
      const vm = this
      if (vm.dynamicTimer) {
        clearTimeout(vm.dynamicTimer)
        vm.dynamicTimer = null
      }
      if (!vm.selfAreaId) {
        this.totalData = []
        // if (this.chart) {
        //   this.chart.destroy();
        // }
        return
      }
      this.loading = true
      const Today = vm.GetDateStr(0, false)
      const params = {
        selfAreaId: vm.selfAreaId,
        year: Today.y,
        month: Today.m
      }
      const params2 = {
        selfAreaId: vm.selfAreaId,
        year: Today.y,
        month: Today.m,
        day: Today.d
      }
      const params3 = {
        selfAreaId: vm.selfAreaId,
        dateGroup: `${vm.GetDateStr(-6)},${vm.GetDateStr(-5)},${vm.GetDateStr(
          -4
        )},${vm.GetDateStr(-3)},${vm.GetDateStr(-2)},${vm.GetDateStr(
          -1
        )},${vm.GetDateStr()}`
      }
      if (!this.isAggregation) {
        params.mold = 1
        params2.mold = 1
        params3.mold = 1
      }
      // 请求一次日  一次月 一次7天
      await Promise.all([
        Api.tidal2(params),
        Api.tidal2(params2),
        Api.tidal2(params3)
      ]).then((res) => {
        vm.totalData = [
          vm.translateDynamicData(res[0].data ? res[0].data : {}),
          vm.translateDynamicData(res[1].data ? res[1].data : {})
        ]
        vm.$nextTick(() => {
          if (res[2].data) {
            this.initScale(this.translateLineData(res[2].data ? res[2].data : {}))
          }
        })
        // 清除定时器 回调自己
        vm.dynamicTimer = setTimeout(vm.getDynamicApi, 150000) // 20s
      })
    },
    translateLineData(data) {
      const arr = []
      this.realNames = []
      let index1 = ''
      Object.entries(data).forEach((p, idx) => {
        const key = p[0]
        for (const val of p[1]) {
          // 如果 7天内 第一个单车 有数值 那每天都要有数据 补全
          if (this.isBicycle) {
            if (val.bike_rent_num || idx === 0) {
              if (idx === 0) {
                index1 = p[1].find((val) => {
                  return val.bike_rent_num > 0
                })
                if (index1) {
                  if (!this.realNames.includes(key.slice(0, 2) + '单车')) {
                    this.realNames.push(key.slice(0, 2) + '单车')
                  }
                  arr.push({
                    pinpai: key.slice(0, 2) + '单车',
                    date: val.date.slice(5),
                    rent: val.bike_rent_num,
                    day: val.date
                  })
                }
              } else {
                if (!this.realNames.includes(key.slice(0, 2) + '单车')) {
                  this.realNames.push(key.slice(0, 2) + '单车')
                }
                arr.push({
                  pinpai: key.slice(0, 2) + '单车',
                  date: val.date.slice(5),
                  rent: val.bike_rent_num,
                  day: val.date
                })
              }
            }
          }
          if (this.isElectricBike) {
            if (val.e_bike_rent_num || idx === 0) {
              if (idx === 0) {
                index1 = p[1].find((val) => {
                  return val.e_bike_rent_num > 0
                })
                if (index1) {
                  if (!this.realNames.includes(key)) {
                    this.realNames.push(key)
                  }
                  arr.push({
                    pinpai: key,
                    date: val.date.slice(5),
                    rent: val.e_bike_rent_num,
                    day: val.date
                  })
                }
              } else {
                if (!this.realNames.includes(key)) {
                  this.realNames.push(key)
                }
                arr.push({
                  pinpai: key,
                  date: val.date.slice(5),
                  rent: val.e_bike_rent_num,
                  day: val.date
                })
              }
            }
          }
        }
      })
      return arr
    },
    translateDynamicData(data) {
      const totalData = Object.entries(data).map((pinpai) => {
        pinpai[1] = pinpai[1].reduce(
          (pre, cur) => {
            if (this.isBicycle) {
              pre.bike_rent_num += cur.bike_rent_num
            }
            if (this.isElectricBike) {
              pre.e_bike_rent_num += cur.e_bike_rent_num
            }
            return pre
          },
          {
            bike_rent_num: 0,
            e_bike_rent_num: 0
          }
        )
        return {
          name: pinpai[0],
          data: pinpai[1]
        }
      })

      const newTotalData = []
      // 品牌分电车 单车
      for (const val of totalData) {
        if (this.isBicycle) {
          if (val.data.bike_rent_num) {
            newTotalData.push({
              name: val.name.slice(0, 2) + '单车',
              rent: val.data.bike_rent_num // 单车的租量
            })
          }
        }
        if (this.isElectricBike) {
          if (val.data.e_bike_rent_num) {
            newTotalData.push({
              name: val.name,
              rent: val.data.e_bike_rent_num // 单车的租量
            })
          }
        }
      }

      const totolRent = newTotalData.reduce((pre, cur) => {
        pre += cur.rent
        return pre
      }, 0)
      return {
        totolRent,
        data: newTotalData,
        isL4: newTotalData.length > 4
      }
    },
    pre(key) {
      // 末尾放到第一
      this.totalData[key].data.unshift(this.totalData[key].data.pop())
    },
    next(key) {
      // 第一移到末尾
      this.totalData[key].data.push(this.totalData[key].data.shift())
    },
    initScale(data) {
      // 正序
      data.sort((a, b) => {
        return new Date(a.day) - new Date(b.day)
      })
      // 有id表示自定义
      if (data.length === 0) {
        return
      }
      if (this.chart) {
        this.chart.destroy()
      }
      this.chart = new Line('c2', {
        data,
        autoFit: true,
        xField: 'date',
        yField: 'rent',
        seriesField: 'pinpai',
        legend: {
          position: 'top-left',
          flipPage: false,
          itemName: {
            style: {
              fill: '#00DADA'
            }
          }
        },
        point: {
          shape: () => {
            return 'circle'
          },
          size: 3
        },
        // 使用函数形式精确匹配品牌颜色
        color: (datum) => {
          const colorMap = this.getColorsByNames()
          // 直接从映射对象获取对应品牌颜色
          return colorMap[datum.pinpai] || this.color16() // 添加默认颜色兜底
        },
        tooltip: {
          customContent: (title, items) => {
            // 数组对象去重
            const newArr = () => {
              const map = new Map()
              for (const item of items) {
                if (!map.has(item.name)) {
                  map.set(item.name, item)
                }
              }
              return [...map.values()]
            }
            const newItems = newArr()
            const sum = newItems.reduce((p, c) => {
              return Number(p) + Number(c.value)
            }, 0) // 25
            let itemHtml = ''
            for (const val of newItems) {
              itemHtml += `<li class="g2-tooltip-list-item" >
                  <span  class="g2-tooltip-marker" style="background:${val.color}"></span>
                  <span class="g2-tooltip-name">${val.name}</span>:
                  <span class="g2-tooltip-value">${val.value}</span>
                </li>`
            }
            const html =
              `
              <div class="g2-tooltip-title">${title} 租车总量：${sum}</div>
              <ul class="g2-tooltip-list">` +
              itemHtml +
              `</ul>
            `
            return html
          }
        }
      })
      this.chart.render()
      this.loading = false
    }
  },
  beforeDestroy() {
    if (this.dynamicTimer) {
      clearTimeout(this.dynamicTimer)
      this.dynamicTimer = null
    }
  }
}
</script>

<style lang='less' scoped>
.flex {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.month_float{
  float: left;
}
.div_width{
  width: 130px;
}
.month {
  display: flex;
  /* float: left;*/
  flex-direction: col;
  margin-top: 16px;
  &.day {
    .month_total {
      color: #00da98;
    }
    .month_list {
      border-left: 3px solid #00da98;
      background: linear-gradient(
        90deg,
        rgba(0, 218, 152, 0.4) 0%,
        rgba(0, 218, 218, 0.05) 100%
      );
    }
  }
  .month_total {
    width: 78px;
    text-align: center;
    color: #00dada;
    padding: 9px 0;
    span {
      font-size: 20px;
    }
    P {
      font-size: 12px;
    }
  }
  .month_flex {
    flex: 1;
  }
  .month_width{
    width: 180px;
  }
  .month_list {
    font-size: 13px;
    /*flex: 1;*/
    background: linear-gradient(
      90deg,
      rgba(0, 218, 218, 0.4) 0%,
      rgba(0, 218, 218, 0.05) 100%
    );
    border-left: 3px solid #00dada;
    display: flex;
    overflow: hidden;
    margin-right: 16px;
    position: relative;
    i {
      color: #00dada;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      font-size: 16px;
      cursor: pointer;
      z-index: 1;
      &.el-icon-arrow-right {
        right: 0;
      }
    }
    > div {
      color: rgba(255, 255, 255, 0.65);
      flex: 1;
      text-align: center;
      padding: 9px 0;
      position: relative;
      /* width: 130px;*/
      &.isL4 {
        flex: 0 0 25%;
        &:nth-child(6):after {
          display: none;
        }
      }
      > div:first-child {
        margin-bottom: 9px;
      }
      &:not(:last-child)::after {
        content: "";
        position: absolute;
        right: 0;
        top: 50%;
        height: 25px;
        width: 1px;
        background: rgba(255, 255, 255, 0.65);
        transform: translateY(-50%);
      }
    }
  }
}

.chart_q {
  padding: 16px;
  flex: 1;
  display: flex;
  flex-direction: column;
  h4 {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    color: #00dada;
    line-height: 18px;
  }
  #c2 {
    flex: 1;
    height: 150px;
  }
}

/deep/.g2-tooltip {
  background: #021922 !important;
  box-shadow: 0px 0px 8px 0px rgba(0, 218, 218, 0.3) !important;
  .g2-tooltip-title {
    font-size: 14px;
    color: #00dada;
  }
  .g2-tooltip-list {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.85);
  }
}
</style>
